import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalDialog from '../ModalDialog';
import './_styles_/VariablesProvidingPopup.css';

VariablesProvidingPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    variablesProvidingComp: PropTypes.func.isRequired,
};

function VariablesProvidingPopup(props) {
    const {
        onConfirm,
        onCancel,
        variablesProvidingComp,
    } = props;
    const { t } = useTranslation();
    const [variables, setVariables] = useState(null);
    const [isValid, setValid] = useState(false);
    const onConfirmWithVariables = () => {
        onConfirm(variables);
    };
    return (
        <ModalDialog onCancel={onCancel}>
            <div className="variables-providing-popup-dialog" role="dialog" aria-modal>
                <h4>{t('misc.provide-additional-values')}</h4>
                <div className="variables-providing-popup-dialog--fields">
                    {variablesProvidingComp(setVariables, setValid)}
                </div>
                <div className="buttons">
                    <button
                        type="button"
                        className="continue-button button-filled-red button"
                        onClick={onConfirmWithVariables}
                        disabled={!isValid}
                    >
                        {t('button.continue')}
                    </button>
                    <button
                        type="button"
                        className="cancel-button button-bordered button"
                        onClick={onCancel}
                    >
                        {t('button.cancel')}
                    </button>
                </div>
            </div>
        </ModalDialog>
    );
}

export default VariablesProvidingPopup;
